// extracted by mini-css-extract-plugin
export default {"container":"style_container__l1PAc","text":"style_text__UlrNF","disable":"style_disable__P3nvs"};